<template>
  <div>
    <search-box
      :columns="searchBoxColumns"
      @search="search"
      :defaultValue="formData"
      @btnReset="handleReset"
    />
    <el-button
      type="primary"
      size="small"
      @click="linkToAddTmp"
      v-if="judgePermission('addContractTemplate')"
    >新增合同模板</el-button>

    <QS-common-table
      :data="tableData"
      :columns="tableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
      v-loading="tableLoading"
    />
  </div>
</template>
<script>
import config from './config.js'
import { contractTemplateModule } from '@/store/dict/withholdDict'
import {
  contractTemplateListApi,
  contractTemplateUpdateState,
} from './services'
import { contractTemplateEffectPreviewV2Api } from '@/api/domain/organize'

export default {
  data() {
    const { tableColumns, searchBoxColumns } = config.call(this)
    return {
      tableColumns,
      searchBoxColumns,
      tableData: [],
      formData: {
        state: 2,
      },
      tableLoading: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      isSubmit: true,
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    handleTemplatecheck(e) {
      if (!e) {
        if (e.length > 100) {
          this.$message.error('合同模板名称最多支持输入100位')
          this.isSubmit = false
        } else {
          this.isSubmit = true
        }
      }
    },
    search(formData) {
      if (this.isSubmit) {
        this.paginationData.pageSize = 10
        this.paginationData.pageNum = 1

        this.formData = formData
        this.getList()
      } else {
        this.$message.error('合同模板名称最多支持输入100位')
      }
    },
    handleReset() {
      this.formData = { state: 2 }
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.getList()
    },
    // 跳转合同模板新增
    linkToAddTmp(isCopy = false, id) {
      this.$router.push({
        path: '/tenantNew/contractTemplate/add',
        query: {
          addFlag: true,
          isCopy,
          id,
          moduleName: contractTemplateModule.entrustWithholdContractTemplate,
        },
      })
    },
    // 分页
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getList()
    },
    // 编辑合同模版
    // eslint-disable-next-line vue/no-unused-properties
    editContractTemplate(row) {
      this.$router.push({
        path: '/tenantNew/contractTemplate/edit',
        query: {
          id: row.id,
          editFlag: true,
          moduleName: contractTemplateModule.entrustWithholdContractTemplate,
        },
      })
    },
    // 复制合同模版
    // eslint-disable-next-line vue/no-unused-properties
    async copyContractTemplate(row) {
      this.linkToAddTmp(true, row.id)
    },
    // 启用 停用 合同模版
    // eslint-disable-next-line vue/no-unused-properties
    entrustWithholdDisabledOrDisabled(row) {
      contractTemplateUpdateState({
        id: row.id,
        bizType: 2,
        state: row.state === 0 ? 1 : 0,
      }).then((res) => {
        if (res) {
          const { code } = res
          if (code === 1) {
            this.$message.success(`${row.state === 0 ? '启用' : '停用'}成功`)
            this.handleRefreshList()
          }
        }
      })
    },
    // 预览合同
    // eslint-disable-next-line vue/no-unused-properties
    previewContractTemplate(row) {
      contractTemplateEffectPreviewV2Api({
        id: row.id,
        bizType: 2,
      }).then((res) => {
        if (res) {
          const { code, data } = res
          if (code === 1) {
            window.open(data, '_blank')
          }
        }
      })
    },
    // 更新列表
    handleRefreshList() {
      this.getList()
    },
    async getList() {
      contractTemplateListApi({
        ...this.formData,
        state: this.formData.state === 2 ? '' : this.formData.state,
        bizType: 2,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }).then((res) => {
        if (res) {
          const { code, data } = res
          if (code === 1) {
            this.tableData = data.items || []
            this.paginationData.total = data.totalNum
          }
        }
      })
    },
  },
  created() {
    this.getList()
  },
  activated() {
    this.getList()
  },
}
</script>
